<div class="sticky-wrapper sticky-top z-1050">
  <nav class="navbar navbar-expand-xl navbar-dark bg-dark-subtle sticky-top fs-5">
    <a class="navbar-brand" (click)="collapseNavbar()" routerLink="">
      <img class="ms-2" src="images/logos/thumper_games_bot_no_cord_50_percent_quality.png" alt="Icon" width="38"
        height="38" style="border-radius:20%;">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto">
        <li class="nav-item dropdown">
          <button class="nav-link dropdown-toggle thumper-nav-trigger" type="button" id="thumperChessNavDropdown"
            data-bs-toggle="dropdown" aria-expanded="false">
            <i class="{{iconService.getIconClass('Thumper Chess')}} me-1"></i>
            <span>Thumper Chess</span>
            <span class="free-to-play-nav-badge">Free to play</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="thumperChessNavDropdown">
            <li>
              <a class="dropdown-item" (click)="collapseNavbar()" routerLink="/games/thumper-chess"
                routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <i class="{{iconService.getIconClass('Thumper Chess')}} me-2"></i>Overview
              </a>
            </li>
            <li>
              <a class="dropdown-item" (click)="collapseNavbar()" routerLink="/games/thumper-chess/leaderboards"
                routerLinkActive="active">
                <i class="{{iconService.getIconClass('Leaderboards')}} me-2"></i>Leaderboards
              </a>
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown">
          <button class="nav-link dropdown-toggle thumper-nav-trigger" type="button" id="pluginsNavDropdown"
            data-bs-toggle="dropdown" aria-expanded="false">
            <i class="{{iconService.getIconClass('Plugins')}} me-1"></i>UE5 Plugins
          </button>
          <ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="pluginsNavDropdown">
            <li>
              <a class="dropdown-item plugin-dropdown-item" (click)="collapseNavbar()" routerLink="/plugins/database-communicator"
                routerLinkActive="active">
                <i class="{{iconService.getIconClass('Database Communicator')}} me-2"></i>
                <span class="plugin-dropdown-label">Database Communicator</span>
                <span class="plugin-dropdown-badge">Free</span>
              </a>
            </li>
            <li>
              <a class="dropdown-item" (click)="collapseNavbar()" routerLink="/plugins/openapi" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <i class="{{iconService.getIconClass('OpenAPI')}} me-2"></i>OpenAPI
              </a>
            </li>
          </ul>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="collapseNavbar()" routerLink="/contact" routerLinkActive="active">
            <i class="{{iconService.getIconClass('Contact')}} me-1"></i>Contact
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="collapseNavbar()" href="https://discord.gg/Sd4B2rm" target="_blank"
            rel="noopener">
            <i class="{{iconService.getIconClass('Support')}} me-1"></i>Support
          </a>
        </li>
      </ul>
      <ul class="navbar-nav ms-auto">
        <li *ngIf="isAuthenticated" class="nav-item">
          <a class="nav-link" (click)="collapseNavbar()" routerLink="/account">
            <i class="{{iconService.getIconClass('Account')}} me-1"></i>Welcome {{ username || 'back' }}
          </a>
        </li>
        <li *ngIf="isAuthenticated && isAdmin" class="nav-item">
          <a class="nav-link" (click)="collapseNavbar()" routerLink="/admin">
            <i class="{{iconService.getIconClass('Admin')}} me-1"></i>Admin
          </a>
        </li>
        <li *ngIf="!isAuthenticated" class="nav-item">
          <a class="nav-link" (click)="collapseNavbar()" routerLink="/login">
            <i class="{{iconService.getIconClass('Login')}} me-1"></i>Login
          </a>
        </li>
        <li *ngIf="!isAuthenticated" class="nav-item">
          <a class="nav-link" (click)="collapseNavbar()" routerLink="/register">
            <i class="{{iconService.getIconClass('Register')}} me-1"></i>Register
          </a>
        </li>
        <li *ngIf="isAuthenticated" class="nav-item">
          <a class="nav-link" role="button" (click)="logout(); collapseNavbar()">
            <i class="{{iconService.getIconClass('Log out')}} me-1"></i>Log out
          </a>
        </li>
      </ul>
    </div>
  </nav>

  <!--Notifications-->
  <div class="container-fluid px-3 alert-container" *ngIf="message.length || error.length">
    <div *ngIf="message.length" class="alert alert-success alert-dismissible fade-in-out mb-0"
      [ngClass]="{ 'hidden': !isMessageVisible }" role="alert">
      <ul class="mb-0">
        <li *ngFor="let msg of message">{{ msg }}</li>
      </ul>
      <button type="button" class="btn-close" aria-label="Close"
        (click)="message = []; isMessageVisible = false;"></button>
    </div>
    <div *ngIf="error.length" class="alert alert-danger alert-dismissible fade-in-out mb-0"
      [ngClass]="{ 'hidden': !isErrorVisible }" role="alert">
      <ul class="mb-0">
        <li *ngFor="let err of error">{{ err }}</li>
      </ul>
      <button type="button" class="btn-close" aria-label="Close" (click)="error = []; isErrorVisible = false;"></button>
    </div>
  </div>
</div>
